export type Teil = { text: string } | { verweis: number }

/** Zerlegt eine Antwort in Text und Quellenverweise: "Bernd mag Laphroaig [2][3]." */
export function antwortTeile(antwort: string, gueltig: Set<number>): Teil[] {
  const teile: Teil[] = []
  let rest = 0
  for (const m of antwort.matchAll(/\[(\d+)\]/g)) {
    const nr = Number(m[1])
    if (!gueltig.has(nr)) continue // Nummern ohne Quelle bleiben unsichtbar
    if (m.index! > rest) teile.push({ text: antwort.substring(rest, m.index) })
    teile.push({ verweis: nr })
    rest = m.index! + m[0].length
  }
  if (rest < antwort.length) teile.push({ text: antwort.substring(rest) })
  return teile.map((t) => ('text' in t ? { text: t.text.replace(/\s*\[\d+\]/g, '') } : t)).filter((t) => !('text' in t) || t.text)
}
